
import { useContext, useEffect, useMemo, useRef } from "react"
import { MediaMobile, MediaTablet } from "../../../../api/const/MediaQuery"
import useMediaQuery from "../../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../../shared/GeneralContext/GeneralContext"
import { useLocation, useNavigate } from "react-router-dom"
import { CircularProgress } from "@mui/material"
import { DatesResponseType, initialStateModal } from "components/types/types"
import Lottie from "lottie-react"
import success from "../../../../assets/lottie/success.json"
import { useGuestView } from "shared/GeneralContext/GuestContext"
import { LoginType } from "components/types/Context"
import { Button, Loader } from "components/atoms"




export const Response = (props: any) => {
    const { dateResponse, loginType , setModalDatesIsOpen, setModal, setstartUpIdforMatch} = useContext(AppGeneralContext)
    const mobile = useMediaQuery(MediaMobile)
    const tablet = useMediaQuery(MediaTablet)
    const location = useLocation()
    const lottieRef = useRef<any>();
    const {setCanMatch} = useGuestView()
    const navigate = useNavigate()

    useEffect(() => {
        if (props.currentStep === 5) {
            setCanMatch(undefined)
        }
    }, [])


    useEffect(() => {
        if (props.currentStep === 5) {
            if (dateResponse.type === DatesResponseType.respUndefined) {
                props.goToStep(4)
            }
        }
    }, [dateResponse.type, props.currentStep])

    const showResponse = 
    useMemo(
        () => {
        if (dateResponse.type === DatesResponseType.respUndefined) {
            return null
        }

        if (dateResponse.type === DatesResponseType.respLoading) {
            return (
                <div className="d-flex h-100 flex-column align-items-center justify-content-center">
                    <div className="w-100 d-flex align-items-center justify-content-center pt-4 ">
                        <div className="d-flex pe-4 align-items-center justify-content-center ">
                           <Loader/>
                        </div>
                        {/* <h1 className='tx-primary text-center m-0 p-0'>{dateResponse.title}</h1> */}
                    </div>
                    <div className="pt-2 pb-4">
                        <p className="p-0 m-0">{dateResponse.message}</p>
                    </div>
                </div>
            )
        }

        if (dateResponse.type === DatesResponseType.respPositive) {
            return (
                <div className="d-flex h-100 flex-column align-items-center justify-content-center">
                    <div>
                           <Lottie
                                lottieRef={lottieRef}
                                animationData={success}
                                loop
                                className={'success_anim_dates  '}
                            />
      
                </div>
                <div className="w-100 d-flex align-items-center justify-content-center pt-4 ">
                    <h1 className='tx-primary text-center m-0 p-0'>{dateResponse.title}</h1>
                </div>
                <div className="pt-2 pb-4">
                    <p className="p-0 m-0">{dateResponse.message}</p>
                </div>
                <div className="pt-2 pb-4">
                    {loginType === LoginType.guest && 
                    <Button color='var(--white)'
                    background='var(--primary)'
                    borderColor='var(--primary)'
                    fontWeight={'800'}
                    uppercase
                    primary
                    text='Register Now'
                    onClick={() => {
                      setModal(initialStateModal);
                      setModalDatesIsOpen(false)
                      navigate(`/getStarted`)
                    }} />
                    
                    }
                </div>
            </div>
            )
        }

  

        if (dateResponse.type === DatesResponseType.respNegative) {
            return (
                <div className="d-flex h-100 flex-column align-items-center justify-content-center">
                <div className="w-100 d-flex align-items-center justify-content-center pt-4 ">
                    <h1 className='tx-error text-center m-0 p-0'>{dateResponse.title}</h1>
                </div>
                <div className="pt-2 pb-4">
                    <p className="p-0 m-0">{dateResponse.message}</p>
                </div>
            </div>
            )
        }

    }
    , [dateResponse.type])



    return (
        <div className="w-100" style={{ height: "68vh" }}>
            {showResponse}
        </div>
    )

}